<template>
  <button
    type="button"
    class="relative flex min-h-[64px] w-full items-center gap-2.5 px-2.5 py-2.5 text-left"
    @click="$emit('select')"
  >
    <div class="size-9 shrink-0">
      <Thumbnail :type="thumbType" :src="thumbSrc ?? undefined" />
    </div>
    <div class="min-w-0 flex-1">
      <div class="truncate text-[14px] leading-[21px] text-gray-800">
        {{ name }}
      </div>
      <div
        class="mt-0.5 flex min-w-0 items-center gap-1.5 text-[13px] leading-[18px] text-[#5a616b]"
      >
        <slot name="subtitle" />
      </div>
    </div>
    <div
      class="pointer-events-none absolute -right-4 bottom-0 left-[56px] h-px bg-[#efefef]"
    />
  </button>
</template>

<script setup lang="ts">
import { Thumbnail, type ThumbnailType } from '@dacr/library'

defineProps<{
  thumbType: ThumbnailType
  thumbSrc?: string | null
  name: string
}>()

defineEmits<{ select: [] }>()
</script>
